const ClinicalConsultCorner = (
  <div>
    <p>
      Clinical supervision is for therapists on the road to licensure to have a
      safe, collaborative, structured space to build your clinical identity,
      deepen case conceptualization skills, build confidence integrating
      modalities, and gain practical support across a variety of clinical
      settings.
      <br />
      <br />
      <strong style={{ color: "#839abf" }}>Individual Setting</strong>
      <br />
      <strong style={{ color: "#839abf" }}>
        Duration: 1 Hour; Fee: $85
      </strong>
      <br />
      <br />
      <strong style={{ color: "#839abf" }}>Group Setting</strong>
      <br />
      <strong style={{ color: "#839abf" }}>
        Duration: 3 Hours; Fee: $145 {<br />}Meets Once Monthly
      </strong>
      <br />
      <br />
      <h2>Insight Moment</h2>
      Are you an individual clinician seeking consultation on trauma
      presentations, case stuck points, EMDR-informed interventions, or
      practice development? This one-on-one consultation space offers focused
      feedback to support your confidence, clinical growth, and long-term
      professional sustainability.
      <br />
      <br />
      <strong style={{ color: "#839abf" }}>
        Duration: 1 Hour; Fee: $85
      </strong>
    </p>
  </div>
);

export default ClinicalConsultCorner;
